module.exports = __webpack_public_path__ + "media/images/countrysquared/zw-a60a14eea61f9ca92bf4b23dda0d5f48.svg";